import { fetchMobilePolicies } from "../../api/mobileVersionPolicy";
import { createResourceLoader } from "./keyedResourceLoader";
import type { AdministrationSlice, MobilePolicySlice } from "./types";

const loader = createResourceLoader();
export const mobilePolicyInitialState = {
  policies: [],
  policiesHydrated: false,
  policiesLoading: false,
  policiesError: "",
};
export const resetMobilePolicyRequests = loader.clear;
export const createMobilePolicySlice: AdministrationSlice<MobilePolicySlice> = (set, get) => ({
  ...mobilePolicyInitialState,
  loadPolicies: (force = false) => loader.load({
    force,
    cached: get().policiesHydrated,
    request: fetchMobilePolicies,
    onStart: () => set({ policiesLoading: true, policiesError: "" }),
    onSuccess: (policies) => set({ policies, policiesHydrated: true }),
    onError: (policiesError) => set({ policiesError }),
    onFinish: () => set({ policiesLoading: false }),
    errorMessage: "Unable to load mobile app policies.",
  }),
  replacePolicy: (updated) => set((state) => ({
    policies: state.policies.map((policy) => (
      policy.platform === updated.platform ? updated : policy
    )),
    policiesHydrated: true,
  })),
});
